import BaseAPI from './base.api.service'

const resource = 'locations';
export default {
    async getForeign() {
        return await BaseAPI.get(`${resource}/foreign`);
    },
    async getForeignByCityORCountry(query) {
        return await BaseAPI.get(`${resource}/Foreign?searchQuery=${query}`);
    },
    async getUSTerritoryByCityOrCountry(query) {
        return await BaseAPI.get(`${resource}/OtherDomestic?searchQuery=${query}`);
    },
    async getDomestic() {
        return await BaseAPI.get(`${resource}/domestic`);
    },
    async getDomesticByZip(zip) {
        return await BaseAPI.get(`${resource}/domestic?zipCode=${zip}`);
    }
}